import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import com_logo from "../Home/Home_modules/Im/com_logo.png";

class Mobile_Menu_Public extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.menuPopup = this.menuPopup.bind(this);
        this.menuClose = this.menuClose.bind(this);
        this.notificationPopup = this.notificationPopup.bind(this);
        this.notificationClose = this.notificationClose.bind(this);
    }
    menuPopup(){
        document.querySelector('.mobile-menu-popup').classList.add('mobile-menu-popup-active')
    }
    menuClose(){
        document.querySelector('.mobile-menu-popup').classList.remove('mobile-menu-popup-active')
    }
    notificationPopup(){
        document.querySelector('.notification-container').classList.add('notification-container-active')
    }
    notificationClose(){
        document.querySelector('.notification-container').classList.remove('notification-container-active')
    }


    render(){
        return(
            <>
                <div className="mobile-menu-container">
                    <div>
                    <Link to="/"><img className="mobile-com-logo" src={com_logo} alt="Logo" /></Link>
                    </div>
                    <div className="mobile-menu-content">
                    <Link to="/wallet"><i class='fas fa-wallet' ></i></Link>
                   {/*<button className='notification-bell'><i class="fas fa-bell"></i></button>*/}
                    <button onClick={this.menuPopup} className="menu-bt-icon"><i class="fas fa-bars"></i></button>
                    </div>
                </div>

                {/* Mobile Menu Popup */}
                <div className="mobile-menu-popup">
                    <div className="mobile-menu-popup-content">
                        <div className="mobile-menu-popup-content-header">
                            <h3>English</h3>
                            <button onClick={this.menuClose} className="menu-popup-close">X</button>
                        </div>
                        <div className="mobile-menu-popup-content-body">
                            <ul>
                                <li><Link onClick={this.menuClose} to="/collections">Collections</Link></li>
                                <li><Link onClick={this.menuClose} to="/marketplace">Marketplace</Link></li>
                                <li><Link onClick={this.menuClose} to="/how it works">How it works</Link></li>
                                <li><Link onClick={this.menuClose} to="/blog">Blog</Link></li>
                                <li><Link onClick={this.menuClose} to="/about">About</Link></li>
                                {/*<li><Link onClick={this.menuClose} to="/">D-Game</Link></li>*/}
                                <li><Link onClick={this.menuClose} to='/contact'>Contact</Link></li>
                            </ul>
                        </div>
                        <div className="mobile-menu-popup-content-footer">
                            <a class="fb-ic menu-social-ic">
                            <a href="https://www.facebook.com/diginoornft/" target="_blank"><i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="tw-ic menu-social-ic">
                            <a href="https://twitter.com/diginoor_NFT" target="_blank"><i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="gplus-ic menu-social-ic">
                            <a href="https://discord.gg/C2APxt2h4P" target="_blank"><i class="fab fa-discord fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="li-ic menu-social-ic">
                            <a href="https://www.linkedin.com/company/diginoor" target="_blank"> <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="ins-ic menu-social-ic">
                            <a href="https://www.instagram.com/diginoor.io" target="_blank"><i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a> 
                            </a>
                            <a class="pin-ic menu-social-ic">
                            <a href="https://wa.me/+15714120310" target="_blank"> <i class="fab fa-whatsapp fa-lg white-text fa-2x"> </i></a>
                            </a>
                            <a class="pin-ic menu-social-ic">
                            <a href="https://t.me/+LsXcY48EHCMwMGU1" target="_blank"> <i class="fab fa-telegram fa-lg white-text fa-2x"> </i></a>
                            </a>
                            <div className="mobile-menu-btns">
                            <div className="log-btt">
                             <p className="log-btt-text"><Link to="/login">Login</Link></p>
                            </div>
                            <div className="signup-btt">
                              <p  className="log-btt-text-signup"><Link to="/signup">Signup</Link></p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="notification-container">
        <div className="notification-box">
            <div className="notification-box-header">
                <h3>Notifications</h3>
                <button className="notification-close" onClick={this.notificationClose}>x</button>
            </div>
                <div className='notification-list'>
                    <div className='notification-list-item'>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>Your NFT Sivaji: The boss was sold for $120 (0.3494 ETH) in the marketplace.</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                    <div className='notification-list-item'>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>Your NFT Sivaji: The boss was sold for $120 (0.3494 ETH) in the marketplace.</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                    <div className='notification-list-item'>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>Your NFT Sivaji: The boss was sold for $120 (0.3494 ETH) in the marketplace.</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                    <div className='notification-list-item'>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>Your NFT Sivaji: The boss was sold for $120 (0.3494 ETH) in the marketplace.</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                    <div className='notification-list-item'>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>Your NFT Sivaji: The boss was sold for $120 (0.3494 ETH) in the marketplace.</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                </div>
        </div>
    </div>
            </>
        )
    }
}

export default Mobile_Menu_Public;